<template>
    <data-table
        :columns="columns"
        :classes="classes"
        :per-page="['20']"
        :debounce-delay=100
        order-by="start_date"
        url="/api/events">

        <div slot="filters" slot-scope="{ tableData, perPage }">
            <div class="row mb-2">
                <div class="col-md-3">
                    <input
                        name="name"
                        class="form-control"
                        v-model="tableData.search"
                        placeholder="Search for Events">
                </div>
            </div>
        </div>
    </data-table>
</template>

<script>
    import DatatableColTitle from "./DatatableColTitle";
    import DatatableColDate from "./DatatableColDate";
    import DatatableColRegister from "./DatatableColRegister";


    export default {
        name: "EventDatatable",
        data() {
            return {
                columns: [
                    {
                        label: 'Date',
                        name: 'start_date',
                        orderable: true,
                        component: DatatableColDate,
                    },
                    {
                        label: 'Event',
                        name: 'name',
                        orderable: true,
                        component: DatatableColTitle,
                    },
                    {
                        label: 'Register',
                        name: 'register',
                        orderable: true,
                        component: DatatableColRegister,
                    },
                ],
                classes: {
                    table: {
                        'table' : true,
                        'bg-white' : true,
                        'event-rows' : true,
                    },
                    "t-head-tr": {
                        'd-none' : true,
                    },
                    "t-body-tr": {
                        'row-styled': true,
                    },
                    "td": {
                        'p-0': true,
                        //'border-0' : true,
                    }
                }
            }
        },
        components: {
            DatatableColTitle,
            DatatableColDate,
            DatatableColRegister
        },
    }
</script>

<style scoped>

</style>
